var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisasvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 391.8 236.4",
    enableBackground: "new 0 0 391.8 236.4",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6.6,
    fill: "#FFFFFF",
    width: 380.2,
    height: 223.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M377.8,9c2.8,0,5,2.3,5,5v208.4c0,2.8-2.3,5-5,5H14c-2.8,0-5-2.3-5-5V14c0-2.8,2.3-5,5-5H377.8 M377.8,0H14 C6.3,0,0,6.3,0,14v208.4c0,7.8,6.3,14,14,14h363.7c7.8,0,14-6.3,14-14V14C391.8,6.3,385.5,0,377.8,0L377.8,0z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#00589F",
    points: "148.1,157.9 161.2,81.2 182.1,81.2 169,157.9  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00589F",
    d: "M244.9,83.1c-4.1-1.6-10.6-3.2-18.8-3.2c-20.7,0-35.2,10.4-35.4,25.3c-0.1,11,10.4,17.2,18.3,20.9 c8.1,3.8,10.9,6.2,10.8,9.5c-0.1,5.1-6.5,7.5-12.5,7.5c-8.4,0-12.8-1.2-19.7-4l-2.7-1.2l-2.9,17.2c4.9,2.1,13.9,4,23.3,4.1 c22,0,36.3-10.3,36.4-26.2c0.1-8.7-5.5-15.4-17.6-20.9c-7.3-3.6-11.8-5.9-11.7-9.5c0-3.2,3.8-6.6,12-6.6 c6.8-0.1,11.8,1.4,15.7,2.9l1.9,0.9L244.9,83.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00589F",
    d: "M298.6,81.2h-16.2c-5,0-8.8,1.4-11,6.4L240.4,158h22c0,0,3.6-9.5,4.4-11.5c2.4,0,23.8,0,26.8,0 c0.6,2.7,2.5,11.5,2.5,11.5h19.4L298.6,81.2 M272.8,130.7c1.7-4.4,8.3-21.5,8.3-21.5c-0.1,0.2,1.7-4.4,2.8-7.3l1.4,6.6 c0,0,4,18.3,4.8,22.2H272.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00589F",
    d: "M130.5,81.2L110,133.6l-2.2-10.6c-3.8-12.3-15.7-25.6-29-32.2l18.7,67.1l22.1,0l32.9-76.6H130.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9A51A",
    d: "M91,81.2H57.3L57,82.8c26.3,6.4,43.6,21.7,50.8,40.2l-7.3-35.3C99.2,82.8,95.6,81.3,91,81.2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisasvg);
export default __webpack_public_path__ + "static/media/visasvg.290e8ad1f2cc32d37017dd8b676f3ea3.svg";
export { ForwardRef as ReactComponent };